import { HButtonProps } from '../../types/elements';
import classNames from 'classnames';
import Spinner from 'react-bootstrap/Spinner';

const HButton = (props: HButtonProps) => {
    const {
        size = 'lg',
        block = false,
        loading = false,
        disabled = false,
        customClass,
        width = 150,
        title,
        btnType = 'white',
        ...restProps
    } = props;

    const buttonStyles = classNames({
        'h-btn': true,
        [`${customClass}`]: customClass,
        [`h-btn-${btnType}`]: true,
        [`h-btn-${size}`]: true,
        [`h-btn-width-${width}`]: !block,
        'h-btn-block': block,
        disabled: loading || disabled,
    });

    return (
        <button className={buttonStyles} {...restProps} disabled={loading || disabled}>
            {!loading && title}
            {loading && <Spinner animation="border" variant="light" size="sm" />}
        </button>
    );
};

export default HButton;
